/* eslint-disable sonarjs/no-duplicate-string */
import { ProtectionMenuNameOptions, ProtectionPageName } from '../../../utils/enums';
import { Step } from '../../../model/step';

const AllowImg = '<img src="/static/img/switch-icon-green.png" />';
const BlockImg = '<img src="/static/img/switch-icon-red.png" />';
const DotsImg = '<img src="/static/img/dots.png" />';
const AlertImg = '<img src="/static/img/alert.png" />';
const BlockProtectionPlusImg = '<img src="/static/img/block.png" />';

export const StepList: Step[] = [
    new Step({
        index: 0,
        title: ProtectionPageName.GeoFiltering,
        content: `Easily control access to countries that may pose a risk to your business.
                For each country, select to Allow ${AllowImg} or Block ${BlockImg} traffic from your network and from the internet.
                For a hassle-free configuration, Apply AT&T Recommendations from the menu ${DotsImg}`,
        protectionType: ProtectionMenuNameOptions.GEO_FILTERING,
        route: 'geo-filtering'
    }),
    new Step({
        index: 1,
        title: ProtectionPageName.WebFiltering,
        content: `**For Categories** - Allow ${AllowImg} or Block ${BlockImg} traffic to all websites associated to pre-defined categories.
                  For a hassle free configuration, Apply AT&T Recommendations from the menu ${DotsImg}
                  **For Domains** - add custom domains to allow or block based on your business needs.`
        ,
        protectionType: ProtectionMenuNameOptions.WEB_FILTERING,
        route: 'web-filtering',
    }),
    new Step({
        index: 2,
        title: ProtectionPageName.AppsServices,
        content: `Control which services to allow or block access to and from your business.
            For each service, select to Allow ${AllowImg} or Block ${BlockImg} traffic from your network and from the internet.
            For a hassle-free configuration, Apply AT&T Recommendations from the menu ${DotsImg}`,
        protectionType: ProtectionMenuNameOptions.APPS,
        route: 'apps-services',
    }),
    new Step({
        index: 2,
        title: ProtectionPageName.AppsServices,
        content: `Control which services to allow or block access to and from your business.
            For each service, select to Allow ${AllowImg} or Block ${BlockImg} traffic from your network and from the internet.
            For a hassle-free configuration, Apply AT&T Recommendations from the menu ${DotsImg}`,
        protectionType: ProtectionMenuNameOptions.SERVICES,
        route: 'apps-services',
    }),
    new Step({
        index: 3,
        title: ProtectionPageName.IPControl,
        content: `Block or allow traffic based on specific IP Address.
            Add a new IP Address or click to edit an existing IP.`,
        protectionType: ProtectionMenuNameOptions.IP_CONTROL,
        route: 'ip-control',
    }),
    new Step({
        index: 4,
        title: ProtectionPageName.ProtectionPlus,
        content: `Control your Dynamic Defense Shield protection.\n`,
        contentForGoldLevel: `Enhance your security with premium threat protection. Set protection profiles to ${AlertImg} Alert 
        or ${BlockProtectionPlusImg} Block traffic packets with matching signature.`,
        protectionType: ProtectionMenuNameOptions.PROTECTION_PLUS,
        route: 'protection-plus',
    })
];